import * as React from "react";
const Svg16PxArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.37 2.6 7.12 4.28l2.07 2.07-6.57 6.56.48.48 6.56-6.56 2.02 2.02 1.68-6.25ZM8.43 4.63l3.97-1.06-1.06 3.97z", style: {
  fill: "currentColor"
} }));
export default Svg16PxArrow;
